'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReverseButton = exports.AdvanceButton = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _button = require('react-toolbox/lib/button');

var _buttons = require('../buttons');

var buttons = _interopRequireWildcard(_buttons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }
  return t;
};

/**
 * Renders a react-toolbox Button to go to the next step
 *
 * This is just a wrapper around the basic [AdvanceButton](/#/docs/dist/src/buttons.js/component.AdvanceButton)
 * but with Button from react-toolbox passed in the component property.
 *
 * ### Usage
 * ```
 * <AdvanceButton>
 *   Next
 * </AdvanceButton>
 * ```
 */
var AdvanceButton = exports.AdvanceButton = function AdvanceButton(props) {
  return React.createElement(buttons.AdvanceButton, __assign({ component: _button.Button }, props));
};
/**
 * Renders a react-toolbox Button to go to the previous step
 *
 * This is just a wrapper around the basic [ReverseButton](/#/docs/dist/src/buttons.js/component.ReverseButton)
 * but with Button from react-toolbox passed in the component property.
 *
 * ### Usage
 * ```
 * <ReverseButton>
 *   Back
 * </ReverseButton>
 * ```
 */
var ReverseButton = exports.ReverseButton = function ReverseButton(props) {
  return React.createElement(buttons.ReverseButton, __assign({ component: _button.Button }, props));
};
//# sourceMappingURL=buttons.js.map



//////////////////
// WEBPACK FOOTER
// ./dist/src/react-toolbox/buttons.js
// module id = 838
// module chunks = 0